import axios from "axios";
import { baseUrl } from "../apiUrl";
import { buildQueryString, QueryParam } from "../queryUtils";
import { Division, Divisions } from "./types";



// Get all Divisions
export const getAllDivisions = async (query: QueryParam): Promise<Divisions> => {
       try {
              const response = await axios.get<Divisions>(`${baseUrl}/clo-dvs/division?${buildQueryString(query)}`);
              return response.data;
       } catch (error) {
              throw new Error(`Failed to fetch Divisions: ${error}`);
       }
};


export const createDivision = async (division: Division): Promise<Division> => {
       try {
              const response = await axios.post<Division>(`${baseUrl}/clo-dvs/division`, division);
              return response.data;
       } catch (error) {
              throw new Error(`Failed to create Division: ${error}`);
       }
};

// Update a specific Division by ID and divisionCode ID
export const updateDivision = async (division: Partial<Division>): Promise<Division> => {
       try {
              const response = await axios.patch<Division>(`${baseUrl}/clo-dvs/division`, division);
              return response.data;
       } catch (error) {
              throw new Error(`Failed to update Division with ID ${division}: ${error}`);
       }
};